var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.805 21.422V37.75H.727V24.86c0-6.98.833-12.032 2.5-15.157C5.414 5.536 8.877 2.385 13.617.25l3.438 5.469c-2.865 1.198-4.974 2.995-6.328 5.39-1.355 2.344-2.11 5.782-2.266 10.313h7.344zm24.218 0V37.75H24.945V24.86c0-6.98.834-12.032 2.5-15.157 2.188-4.167 5.651-7.318 10.39-9.453l3.438 5.469c-2.864 1.198-4.974 2.995-6.328 5.39-1.354 2.344-2.11 5.782-2.265 10.313h7.343z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.4c0ffa4b2bb604850d1ea12852ac0fb2.svg";
export { ForwardRef as ReactComponent };